.mlnt9r0 {
  background-color: var(--color-neutral-bg-accent-subtle-default__gma9sq77);
  border-radius: var(--size-radius-small__gma9sq8w);
  padding: var(--size-spacing-small__gma9sq9n);
  margin: var(--size-spacing-small__gma9sq9n);
}